import React, { useEffect, useRef, useState } from "react";

interface MosaicWindowWrapperProps {
	children: React.ReactNode;
	className?: string;
}

export const MosaicWindowWrapper: React.FC<MosaicWindowWrapperProps> = ({
	children,
	className = "",
}) => {
	const cardRef = useRef<HTMLDivElement>(null);
	const [height, setHeight] = useState<number | null>(null);
	const [width, setWidth] = useState<number | null>(null);

	useEffect(() => {
		const updateHeight = () => {
			if (cardRef.current) {
				const mosaicWindow = cardRef.current.closest(".mosaic-window");
				if (mosaicWindow) {
					const headerHeight =
						mosaicWindow.querySelector(".mosaic-window-toolbar")
							?.clientHeight || 0;
					const availableHeight = mosaicWindow.clientHeight - headerHeight;

					setHeight(availableHeight);
				}
			}
		};

		const updateWidth = () => {
			if (cardRef.current) {
				const mosaicWindow = cardRef.current.closest(".mosaic-window");
				if (mosaicWindow) {
					const headerWidth =
						mosaicWindow.querySelector(".mosaic-window-toolbar")?.clientWidth ||
						0;

					setWidth(headerWidth);
				}
			}
		};

		const resizeObserver = new ResizeObserver(() => {
			updateHeight();
			updateWidth();
		});

		if (cardRef.current) {
			const mosaicWindow = cardRef.current.closest(".mosaic-window");
			if (mosaicWindow) {
				resizeObserver.observe(mosaicWindow);
				updateHeight();
				updateWidth();
			}
		}

		return () => {
			if (cardRef.current) {
				const mosaicWindow = cardRef.current.closest(".mosaic-window");
				if (mosaicWindow) {
					resizeObserver.unobserve(mosaicWindow);
				}
			}
		};
	}, []);

	const fullHeightEl = cardRef.current?.querySelector("#full-h-el");

	return (
		<div
			className={className}
			ref={cardRef}
			style={
				fullHeightEl
					? { height: "100%" }
					: { height: height ? `${height}px` : "auto" }
			}
		>
			{React.Children.map(children, (child) => {
				return React.cloneElement(
					child as React.ReactElement<{ width: number | null }>,
					{ width },
				);
			})}
		</div>
	);
};
